import React, { Component } from 'react';
import "./textOverImage.css";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  render() {
    var direction
    var fullWidth
    if(this.props.fullWidth){
      fullWidth = "full-width"
    }
    if(this.props.direction){
      if(this.props.direction === "left"){
        direction = "text-over-image-left";
      }
      if(this.props.direction === "right"){
        direction = "text-over-image-right";
      }
    } else{
      direction = "text-over-image-full";
    }

    return (
      <div className={'text-over-image-container background-image-fill'} style={{backgroundImage: `url(${ this.props.image })`}}>
        <div className={'text-over-image-overlay'} style={{backgroundColor: this.props.overlayColor}}>
          <div className={`row ${ direction }`} style={{minHeight:this.props.height}}>
            <div className="small-12 show-for-small">
              <img className="full-width" src={this.props.image} />
            </div>
            <div className={"small-12 medium-6 large-5 row text-over-image-text text-over-image-padding "+fullWidth}>
              <div className="full-width" style={{margin:"auto"}}>
                {this.props.title && <h2 style={{color:this.props.textColor}}>{this.props.title}</h2>}
                {this.props.description && <p style={{color:this.props.textColor}}>{this.props.description}</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/textOverImage/index.js